import { Badge, BlockStack, Box, Button, Card, InlineStack, Text } from '@shopify/polaris';
import React, { useState } from "react";
import ShopifyModal from "../../../../../components/ShopifyModal";
import { store } from "../../../../../store";
import { changeBannerData } from "../../../../../slice";
import {
  getPayonnerAuth,
  getPayonnerAuthOff,
  reqPostDisConnetPayPal,
} from "../../../../../api";

const WalletBox = ({ pageData, getPageData, setPageData }) => {
  // 取消paypal授权
  const [disconnectData, setDisconnectData] = useState({
    disconnectActive: false,
    AuthButtonDisable: false,
  });
  // 取消payonner授权
  const [disconnectPayonnerData, setDisconnectPayonnerData] = useState({
    payonnerOff: false,
    payonnerOffLoading: false,
    payonnerButton: false,
    payonnerLink: "",
  });
  const handleDisconnectModal = (id, open) => {
    setDisconnectData((prev) => ({
      ...prev,
      disconnectActive: open,
    }));
  };
  const handleDisconnectAuth = async () => {
    setDisconnectData((prev) => ({
      ...prev,
      AuthButtonDisable: true,
    }));
    let response = await reqPostDisConnetPayPal();

    if (response.code === "200") {
      setDisconnectData((prev) => ({
        ...prev,
        AuthButtonDisable: false,
      }));
      handleDisconnectModal(0, false);
      // 刷新页面信息
      getPageData();
    } else {
      setDisconnectData((prev) => ({
        ...prev,
        AuthButtonDisable: false,
      }));
      store.dispatch(
        changeBannerData({
          bannerData: {
            show: true,
            desc: response.msg,
          },
        })
      );
    }
  };

  const shopify = window.shopify;
  //payonner 授权
  const handlePayonnerAuth = async () => {
    let params = {
      type: shopify ? 1 : 2,
    };
    setDisconnectPayonnerData((prev) => ({
      ...prev,
      payonnerButton: true,
    }));
    if (disconnectPayonnerData.payonnerLink !== "") {
      window.open(disconnectPayonnerData.payonnerLink, "_blank");
      setDisconnectPayonnerData((prev) => ({
        ...prev,
        payonnerButton: false,
      }));
      return;
    }
    let res = await getPayonnerAuth(params);
    if (res.code === "200") {
      setDisconnectPayonnerData((prev) => ({
        ...prev,
        payonnerLink: res.data.authorization_url,
      }));
      window.open(res.data.authorization_url, "_blank");
    }
    setDisconnectPayonnerData((prev) => ({
      ...prev,
      payonnerButton: false,
    }));
  };
  // 取消授权
  const handlePayonnerDisconnectAuth = async () => {
    setDisconnectPayonnerData((prev) => ({
      ...prev,
      payonnerOffLoading: true,
    }));
    let res = await getPayonnerAuthOff();
    if (res.code === "200") {
      setPageData((prev) => ({
        ...prev,
        payonner: {
          account_id: "",
          email: "",
          expire_time: 0,
          status: 0,
        },
      }));
    }
    setDisconnectPayonnerData((prev) => ({
      ...prev,
      payonnerOffLoading: false,
    }));
  };
  const handlePayonnerAuthOff = () => {
    setDisconnectPayonnerData((prev) => ({
      ...prev,
      payonnerOff: false,
      payonnerOffLoading: false,
    }));
  };

  const disconnectModal = (
    <ShopifyModal id="others-payment-paypal-disconnect-modal"
      open={disconnectData.disconnectActive}
      onClose={() => handleDisconnectModal(0, false)}
      heading={"Cleanup authorized from PayPal"}
      primaryAction={{
        content: "Disconnect",
        onAction: () => handleDisconnectAuth(),
        loading: disconnectData.AuthButtonDisable,
      }}
      secondaryActions={[
        {
          content: "Cancel",
          onAction: () => handleDisconnectModal(0, false),
        },
      ]}
    >
      <p>Are you sure cleanup authorized from PayPal?</p>
      </ShopifyModal>
  );

  const disconnectPayonnerModal = (
    <ShopifyModal id="others-payment-payoneer-revoke-modal"
      open={disconnectPayonnerData.payonnerOff}
      onClose={() => handlePayonnerAuthOff()}
      heading="Revoke Payoneer Authorization"
      primaryAction={{
        content: "Apply",
        onAction: handlePayonnerDisconnectAuth,
        loading: disconnectPayonnerData.payonnerOffLoading,
      }}
      secondaryActions={[
        {
          content: "Cancel",
          onAction: () => handlePayonnerAuthOff(),
        },
      ]}
    >
      <p>
          Are you certain about revoking the authorization for your Payoneer
          account?
        </p>
      </ShopifyModal>
  );
  return (
    <Box>
      <Card>
        <BlockStack gap={300}>
          <Box>
            <Box>
              <Text variant="headingSm" as="h6">
                Others payment method
              </Text>
            </Box>
            <Text as="p" tone="subdued">
              Connect your PayPal or Payoneer for seamless order payments
            </Text>
          </Box>
          <Box style={{ height: "20px" }}>
            <img src="/order_fulfillment/paypal_icon.png" alt="log" />
          </Box>
          <Card padding={0} roundedAbove="xs">
            <Box style={{ background: "rgba(243, 243, 243, 1)" }}>
              <InlineStack blockAlign="center">
                <Box className="store_domain_name store_domain_weight">
                  Account
                </Box>
                <Box className="store_domain_status store_domain_weight">
                  Status
                </Box>
                <Box className="store_domain_api store_domain_weight">
                  Action
                </Box>
              </InlineStack>
            </Box>
            <Box>
              <InlineStack blockAlign="center">
                <Box className="store_domain_name">
                  {pageData?.paypal?.email}
                </Box>
                <Box className="store_domain_status">
                  {pageData?.paypal?.status === 1 &&
                  pageData?.paypal?.is_effective === 1 ? (
                    <Badge tone="success">Active</Badge>
                  ) : (
                    ""
                  )}
                  {pageData?.paypal?.status === 1 &&
                  pageData?.paypal?.is_effective === 0 ? (
                    <Badge tone="warning">Invalid</Badge>
                  ) : (
                    ""
                  )}
                </Box>
                <Box className="store_domain_api">
                  {pageData?.paypal?.status === 1 &&
                  pageData?.paypal?.is_effective === 1 ? (
                    <Button
                      onClick={() => {
                        setDisconnectData((prev) => ({
                          ...prev,
                          disconnectActive: true,
                        }));
                      }}
                    >
                      Disconnect
                    </Button>
                  ) : (
                    <Button
                      size="slim"
                      url={
                        pageData?.paypal?.authUrl
                          ? pageData?.paypal?.authUrl
                          : "#"
                      }
                      external
                    >
                      Connect
                    </Button>
                  )}
                </Box>
              </InlineStack>
            </Box>
          </Card>
          <Box style={{ height: "20px" }}>
            <img src="/order_fulfillment/payonner_icon.png" alt="log" />
          </Box>
          <Card padding={0} roundedAbove="xs">
            <Box style={{ background: "rgba(243, 243, 243, 1)" }}>
              <InlineStack blockAlign="center">
                <Box className="store_domain_name store_domain_weight">
                  Account
                </Box>
                <Box className="store_domain_status store_domain_weight">
                  Status
                </Box>
                <Box className="store_domain_api store_domain_weight">
                  Action
                </Box>
              </InlineStack>
            </Box>
            <Box>
              <InlineStack blockAlign="center">
                <Box className="store_domain_name">
                  {pageData?.payoneer?.account_id}
                </Box>
                <Box className="store_domain_status">
                  {pageData?.payoneer?.status === 1 ? (
                    <Badge tone="success">Active</Badge>
                  ) : (
                    ""
                  )}
                </Box>
                <Box className="store_domain_api">
                  {pageData?.payoneer?.status === 1 ? (
                    <Button
                      onClick={() => {
                        setDisconnectPayonnerData((prev) => ({
                          ...prev,
                          payonnerOff: true,
                        }));
                      }}
                    >
                      Disconnect
                    </Button>
                  ) : (
                    <Button
                      size="slim"
                      loading={disconnectPayonnerData.payonnerOffLoading}
                      onClick={() => handlePayonnerAuth()}
                    >
                      Connect
                    </Button>
                  )}
                </Box>
              </InlineStack>
            </Box>
          </Card>
        </BlockStack>
      </Card>
      {disconnectModal}
      {disconnectPayonnerModal}
    </Box>
  );
};

export default WalletBox;
